import React from "react";
import { FormattedMessage } from "react-intl";
import SummaryUserSituation from "./SummaryUserCountBySituationSection";
import useGetManagementSummary from "../../../hooks/useGetManagementSummary";
import SummaryCommissionSectionManager from "./SummaryCommissionSectionManager";
import { useSelector } from "react-redux";
import ErrorMessage from "../ErrorMessage";
import LoadingSpinner from "../LoadingSpinner";

const SummaryManagement = () => {
  const currentUser = useSelector((state) => state.user.user.me);
  const { summary, loading, error } = useGetManagementSummary();

  if (loading)
    return (
      <LoadingSpinner
        message={<FormattedMessage id="app.loading.fetching" />}
        marginTop={36}
      />
    );

  if (error)
    return (
      <ErrorMessage>
        <FormattedMessage
          defaultMessage={error}
          id={error}
        />
      </ErrorMessage>
    );

  return (
    <>
      <SummaryCommissionSectionManager
        currentUser={currentUser}
        manager={summary.commissionCurrentMonth}
        managerSplit={summary.splitCurrentMonth}
        leadership={summary.oneTimeReceivedCurrentMonth}
        totalCurrentMonth={summary.totalReceivedCurrentMonth}
        totalPreviousMonth={summary.totalReceivedPreviousMonth}
      />
      <SummaryUserSituation
        summary={summary.agentCountBySituation}
        title="app.agents"
        pathname={"/team-management/search"}
        isForAgents
      />
      <SummaryUserSituation
        summary={summary.customerCountBySituation}
        title="app.customers"
        pathname={"/team-management/search"}
      />
    </>
  );
};

export default SummaryManagement;
